<template>
  <div class="version">
    <div class="box">
      <div class="bg"></div>
      <div class="t1">
        <img src="~_img/common/c.png" alt="" />
        <span>当前版本: V1.5</span>
      </div>
      <div class="t2">
        <i></i>
        <span>最新版本: V1.5</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  }
}
</script>

<style lang="less" scoped>
.version{
}
.box {
  width: 760px;
  height: 192px;
  background: linear-gradient(270deg, #f7f7fd 0%, #ffffff 100%);
  box-shadow: 0px 0px 15px 0px rgba(218, 218, 218, 0.5);
  border-radius: 0px 0px 8px 8px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  .bg {
    height: 8px;
    background: linear-gradient(270deg, #b6c1ea 0%, #496ddd 100%);
    border-radius: 8px 8px 0px 0px;
  }
  .t1,
  .t2 {
    margin-left: 220px;
  }
  .t1 {
    display: flex;
    align-items: center;
    font-size: 40px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #496ddd;
    margin-top: 30px;
    img {
      width: 21px;
      margin-right: 10px;
    }
  }
  .t2 {
    display: flex;
    align-items: center;
    i {
      width: 5px;
      height: 5px;
      background: #636363;
      border-radius: 50%;
      margin-right: 28px;
    }
    font-size: 30px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #636363;
    margin-top: 12px;
  }
}
</style>
